var Curriculog = Curriculog || {};

Curriculog.ManageUserRightsView = (function ($, _, Backbone, ManageUserRightsView) {

    ManageUserRightsView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/userRights.html',
        events: {
            'click #save-settings': 'saveSettings',
            'click #cancel-settings': 'render',
        },

        initialize: function (options) {
            this.userID = options.userID;
            this.userRights = options.userRights;
            this.listenTo(this.userRights, 'change', this.render);
            this.render();
        },

        render: function () {
            this.tempChanges = this.userRights.deepClone();
            this.el = nunjucks.render(this.template);
            this.replaceElement(this.el);

            this.renderPreferences();
            this.renderPermissions();
        },

        renderPermissions: function () {
            var subView = new Curriculog.UserPermissionsView({
                permissions: this.userRights.get('permissions'),
            });
            $(this.$el).find('#user-settings-form').prepend(subView.el);
            this.userPermissions = subView;
        },

        renderPreferences: function () {
            var subView = new Curriculog.UserPreferencesView({
                preferences: this.userRights.get('preferences'),
            });
            $(this.$el).find('#user-settings-form').prepend(subView.el);
            this.userPreferences = subView;
        },

        saveSettings: function () {

            var permissions = this.tempChanges.get('permissions');
            var preferences = this.tempChanges.get('preferences');

            for (var key in permissions) {
                var newValue = Number($('#' + key).prop('checked'));
                permissions[key] = newValue;
            };

            for (var key in preferences) {
                var newValue = $('#' + key + ' option:selected').val()
                preferences[key].value = newValue;
            };

            var view = this;
            var userRightsChanges = this.tempChanges.toJSON()
            this.userRights.save(userRightsChanges, {
                wait: true,

                error: function () {
                    view.render();
                    var errorText = 'An error was encountered when updating the user settings.  ';
                    errorText += 'The user settings have not been updated.  Please try again ';
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },
            })

        },
    });
	return ManageUserRightsView;

})($, _, Backbone, Curriculog.ManageUserRightsView || {});
